// Предыдущие визы
export function stepPreviousVisasNew (proxy)
{
    let controller = {
        checked: false,
        input: false,
    }

    // было
    /*
    month: false,
    year: false,
    visitedCheck: false,
    dateVisited: false,
    dateVisitedRFC2822: false,
    refusedCheck: false,
    dateRefused: false,
    dateRefusedRFC2822: false,
    obtainingVisa: false,
    obtainingVisaId: false,
     */

    /*
    proxy.data.dataForm.step5 = {}
    proxy.data.dataForm.step5 = {
        dateRefusedRFC2822: false,
        visitedIranBefore: false,
        visitedIranBeforeId: false,
        visitedIranBeforeMonth : false,
        visitedIranBeforeYear : false,
        visitedCountries : false,
        visitedCountriesId : false,
        visitedIsrael : false,
        visitedIsraelMonth : false,
        visitedIsraelYear : false,
        visitedUSA : false,
        visitedUSAMonth : false,
        visitedUSAYear : false,
        visitedUK : false,
        visitedUKMonth : false,
        visitedUKYear : false,
        visitedCanada : false,
        visitedCanadaMonth : false,
        visitedCanadaYear : false,
        iranVisaDenial : false,
        iranVisaDenialId : false,
        dateRefused : false,
        obtainingVisa : false,
        obtainingVisaId : false,
        iranVisaBefore : false,
        iranVisaBeforeId : false,
        typeFormerIranVisa : false,
        hotelsPlaces : false,
    }*/

    const data = proxy.data
    const step = 'step'+data.step;
    const radioInputs = proxy.fvcContainerId.querySelectorAll('.radio_control_wrapper_js .radio_container input')
    const visitedIranBeforeYear = proxy.fvcContainerId.querySelector('.radio_control_wrapper_js input[data-name=visitedIranBeforeYear]')
    const checkboxs = proxy.fvcContainerId.querySelectorAll('.check_select_group .input_box input[type=checkbox]')
    const iranianVisaBeforeInput = proxy.fvcContainerId.querySelector('.iranian_visa_before .input_control_js')
    const hotelsPlacesInput = proxy.fvcContainerId.querySelector('.hotels_places .input_control_js')

    // Получаем объект с LocalStorage
    const dataLocalStorage = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    if (dataLocalStorage) data.setDataFormAddLocalStorage(data.dataForm[step], dataLocalStorage)

    // временная функция потом удалить
    if (!dataLocalStorage) {
        // Обновляем LocalStorage
        proxy.data.setStepLocalStorage (proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm.step5, proxy.data.step)
    }

    // Заполняем в input данными с dataForm и обновляем dataForm
    data.setTextInputDataForm(proxy.fvcContainerId, data.dataForm[step]);

    // Перезаписываем LocalStorage при выборе с Radio
    // data.setRadioClickLocalStorage(proxy)

    // Вешаем input на год в (Вы посещали ранее Иран)
    BX.bind(visitedIranBeforeYear, 'input', BX.proxy(eventControlYearLocalStorage, proxy));

    // Клик по радио кнопке
    radioInputs.forEach(input => {
        BX.bind(input, 'click', BX.proxy(eventClickRadio, proxy));
        // input.onclick = eventClickRadio;
    })

    loadingControlSelect(proxy);
    controlClickActiveCheckbox(proxy);

    // selControlYearLocalStorage(proxy);
    data.setTextRadioDataForm(proxy, step);
    loadingStaticRadio(radioInputs)
    locStorageControlCheckbox(proxy, checkboxs, dataLocalStorage)

    BX.bind(iranianVisaBeforeInput, 'input', BX.proxy(setEventInputLocSt, proxy));
    BX.bind(hotelsPlacesInput, 'input', BX.proxy(setEventInputLocSt, proxy));

    // Контроль переключения Select
    proxy.data.customSelectActive(proxy);
    loadControlTypeFormerIranVisaRequired(proxy);
    proxy.data.btnNext = true;
}


// Клик по радио кнопке и его контроль с визуальным оформлением
function eventClickRadio (e) {
    const radioControlWrapper = e.target.closest('.radio_control_wrapper_js')
    const disabledControl = radioControlWrapper.querySelector('.disabled_control_js')
    const dCDisableds = disabledControl.querySelectorAll('.disabled_control_js')
    const selectContainer = disabledControl.querySelector('.select_container')
    const radioContainer = e.target.closest('.radio_container')
    const visitedIranBefore  = e.target.closest('.visited_iran_before_wrapper')
    const vcwCustom = e.target.closest('.vcw_custom')
    const iranVasaDenial = e.target.closest('.iran_vasa_denial')
    const radioCont = e.target.closest('.radio_container')
    const iranianVisaBefore  = e.target.closest('.iranian_visa_before ')
    const dtName = e.target.dataset.name

    const dataLS = this.data.getStepLocalStorage(this.locStorStepId, this.data.step);
    dataLS[dtName] = e.target.value;
    dataLS[dtName + 'Id'] = e.target.id

    radioControlBorderCalendar(dataLS)

    const dataName = this.fvcContainerId.querySelector('[data-name=typeFormerIranVisa]')

    // Вы посещали ранее Иран?
    if (!radioCont.classList.contains('rc_yes') && dtName === 'visitedIranBefore') {
        dataLS[dtName + 'Month'] = false
        dataLS[dtName + 'Year'] = false
    }

    // Посещали ли вы эти страны?
    if (!radioCont.classList.contains('rc_yes') && dtName === 'visitedCountries') {
        const vcwCustom = e.target.closest('.vcw_custom')
        const checks = vcwCustom.querySelectorAll('.checkbox_container .input_box input[type=checkbox]')
        const selectContainerMonths = vcwCustom.querySelectorAll('.select_container.month')
        const inputContainerYears = vcwCustom.querySelectorAll('.input_container.year')

        // Деактивируем чекбоксы
        checks.forEach(check => {
            dataLS[check.dataset.name] = false;
        })

        // Деактивируем месяца
        selectContainerMonths.forEach(selectMonth => {
            const selectRadio = selectMonth.querySelector('.option_wrapper input[type=radio]')
            dataLS[selectRadio.dataset.name] = false;
        })

        // Деактивируем год
        inputContainerYears.forEach(inputYear => {
            const input = inputYear.querySelector('.input_container input[type=text]')
            dataLS[input.dataset.name] = false;
        })
    }

    // Ранее вы получали отказ в визе в Иран?
    if (!radioCont.classList.contains('rc_yes') && dtName === 'iranVisaDenial') {
        dataLS['dateRefused'] = false
    }

    // Была ли у вас иранская виза ранее?
    if (!radioCont.classList.contains('rc_yes') && dtName === 'iranVisaBefore') {
        dataLS['typeFormerIranVisa'] = false
        dataName.required = false
    } else if (radioCont.classList.contains('rc_yes') && dtName === 'iranVisaBefore') {
        dataName.required = true
    }

    // Визуальное оформление
    // Если активировали (ДА)
    if (radioContainer.classList.contains('rc_yes'))
    {
        // 1. Удаляем класс _error у родителя
        if (radioControlWrapper.classList.contains('_error')) {
            radioControlWrapper.classList.remove('_error')
        }
        // 2. Удаляем класс disabled
        if (disabledControl.classList.contains('disabled')) {
            disabledControl.classList.remove('disabled')
        }
        // 3. Добавляем класс disabled для года и месяца
        if (dCDisableds) {
            dCDisableds.forEach(item => {
                item.classList.add('disabled')
            })
        }
        // 4. Удаляем класс off
        if (selectContainer && selectContainer.classList.contains('off')) {
            selectContainer.classList.remove('off')
        }

        // Убираем _error в блоке (Была ли у вас иранская виза ранее?)
        if (iranianVisaBefore) {
            const iranianVBDControl = iranianVisaBefore.querySelector('.input_container.disabled_control_js')
            const disabledControlError = iranianVBDControl.classList.contains('_error')
            if (disabledControlError) iranianVBDControl.classList.remove('_error')
            const inputTypeFormerIranVisa = iranianVBDControl.querySelector('input[data-name=typeFormerIranVisa]')
            if (inputTypeFormerIranVisa) {
                inputTypeFormerIranVisa.required = true
            }
        }
    }
    else
    {
        // 1. добавляем класс disabled
        if (!disabledControl.classList.contains('disabled')) {
            disabledControl.classList.add('disabled')
        }
        // 2. добавляем класс off
        if (selectContainer && !selectContainer.classList.contains('off')) {
            selectContainer.classList.add('off')
        }
        // 3. удаляем класс _error
        if (disabledControl.classList.contains('_error')) {
            disabledControl.classList.remove('_error')
        }
        // Очищаем Месяц и год
        if (visitedIranBefore) {
            visitedIranBefore.querySelector('.select_wrapper span').innerText = 'Месяц';
            visitedIranBefore.querySelector('.year input').value = '';
            if (visitedIranBefore.querySelector('.month').classList.contains('_error')) visitedIranBefore.querySelector('.month').classList.remove('_error')
            if (visitedIranBefore.querySelector('.year').classList.contains('_error')) visitedIranBefore.querySelector('.year').classList.remove('_error')
        }

        // Деактивируем в странах список из checkbox, год и месяц
        if (vcwCustom) {
            if (BX('299').closest('.radio_container').classList.contains('_error')) BX('299').closest('.radio_container').classList.remove('_error')
            const chSlGroup = vcwCustom.querySelectorAll('.check_select_group')
            chSlGroup.forEach(checkGroup => {
                const year = checkGroup.querySelector('.year')
                const month = checkGroup.querySelector('.month')
                const checkbox = checkGroup.querySelector('input[type=checkbox]');
                checkGroup.querySelector('.select_wrapper span').innerText = 'Месяц';
                checkGroup.querySelector('.year input').value = '';

                if (year.classList.contains('_error')) year.classList.remove('_error')
                if (year.classList.contains('_success')) year.classList.remove('_success')
                if (month.classList.contains('_error')) month.classList.remove('_error')
                if (month.classList.contains('_success')) month.classList.remove('_success')

                checkbox.checked = false
                if (checkGroup.classList.contains('active')) {
                    checkGroup.classList.remove('active')
                }
            })
        }

        // Деактивируем checkbox в календаре
        if (iranVasaDenial) {
            const disabledControl = iranVasaDenial.querySelector('.disabled_control_js')
            const inputControl = disabledControl.querySelector('.input_control_js')
            inputControl.value = ''
        }

        // Убираем _error если он был проставлен на скрытое поле
        if (iranianVisaBefore) {
            const iranianVBDControl = iranianVisaBefore.querySelector('.input_container.disabled_control_js')
            const disabledControlError = iranianVBDControl.classList.contains('_error')
            if (disabledControlError) iranianVBDControl.classList.remove('_error')
            const inputTypeFormerIranVisa = iranianVBDControl.querySelector('input[data-name=typeFormerIranVisa]')
            if (inputTypeFormerIranVisa) {
                inputTypeFormerIranVisa.required = false
            }
        }
    }

    // Обновляем LocalStorage
    this.data.setStepLocalStorage (this.visual.LOCAL_STORAGE_STEP_ID, dataLS, this.data.step)

}

// Проверка радио кнопок и добавление disabled || удаляем off (визуальное оформление)
function loadingStaticRadio (radioInputs) {
    radioInputs.forEach(radio => {
        const radioControlWrapper = radio.closest('.radio_control_wrapper_js')
        const radioContainer = radioControlWrapper.querySelectorAll('.radio_container')
        const disabledControl = radioControlWrapper.querySelector('.disabled_control_js')
        const month = radioControlWrapper.querySelector('.select_container.month')
        const year = radioControlWrapper.querySelector('.input_container.year')

        /*radioContainer.forEach(radioCont => {
            if (!radioCont.classList.contains('rc_yes')) {
                console.log(radioContainer)
            }
        })*/


        if (!radio.checked) {
            if (!disabledControl.classList.contains('disabled')) {
                disabledControl.classList.add('disabled')
            }
        } else {
            if (disabledControl.classList.contains('disabled')) {
                disabledControl.classList.remove('disabled')
            }
            if (month && month.classList.contains('off')) {
                month.classList.remove('off')
            }

            // if (month) month.querySelector('.select_wrapper span').innerText = 'Месяц';
            // if (year) year.querySelector('input').value = '';
        }
    })
}

// Контролируем ввод Года и записываем данные в LocalStorage
function selControlYearLocalStorage (proxy, container) {

    const year =  container.querySelector('.year')

    // const step = 'step'+proxy.data.step;
    const inputY = year.querySelector('input[type=text]')

    BX.bind(inputY, 'input', BX.proxy(eventControlYearLocalStorage, proxy));
}

// Контролируем ввод Года и записываем данные в LocalStorage
function eventControlYearLocalStorage (e)
{
    // Получаем объект с LC
    const dataLS = this.data.getStepLocalStorage(this.locStorStepId, this.data.step);
    let dataNew = {}
    const year = e.target.closest('.year')
    if (year.classList.contains('_error')) year.classList.remove('_error')
    const value = Number(e.target.value)

    if (value > 0 && value <= new Date().getFullYear()) {
        if (e.target.value.length >= 3) {
            dataNew = {
                ...dataLS,
                [e.target.dataset.name]: value,
            }
            this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, dataNew, this.data.step);
        }
    } else {
        dataNew = {
            ...dataLS,
            [e.target.dataset.name]: false,
        }
        e.target.value = ''
        this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, dataNew, this.data.step);
    }
}

// Контролируем при загрузке Select
function loadingControlSelect(proxy) {
    const step = 'step'+proxy.data.step;
    const selectCont = proxy.fvcContainerId.querySelectorAll('.select_container.month');

    selectCont.forEach(select => {
        const selectWrapper = select.querySelector('.select_wrapper span');
        const options = select.querySelectorAll('.option_wrapper input[type=radio]');
        const dataName = options[0].dataset.name;
        const dataNameValue = proxy.data.dataForm[step][dataName];

        options.forEach(radio => {
            if (radio.value === dataNameValue) {
                radio.checked = true;
                selectWrapper.innerText = proxy.message['MONTH_'+dataNameValue];
            }
        })
    })
}

// Контролируем загрузку чекбокса и его клик, данные записываем в LocalStorage
function controlClickActiveCheckbox (proxy) {
    const checkbox = proxy.fvcContainerId.querySelectorAll('.checkbox_container input[type=checkbox]')
    const step = 'step'+proxy.data.step;

    checkbox.forEach(check => {
        const dataName = check.dataset.name

        // proxy.data.dataForm[step][check.dataset.name] = !!check.checked;

        // proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataNew, proxy.data.step);

        // вешаем клик по чекбоксу
        BX.bind(check, 'click', BX.proxy(setCheckboxLocalStorage, proxy));
    })



    // Контролируем Checkbox и записываем данные в LocalStorage
    function setCheckboxLocalStorage (e) {
        const step = 'step'+this.data.step;
        const target = e.target
        const dataName = target.dataset.name
        const checkSelectGroup = target.closest('.check_select_group')
        const disabledControl = checkSelectGroup.querySelector('.disabled_control_js')
        const monthContainer = checkSelectGroup.querySelector('.select_container.month')
        const yearContainer = checkSelectGroup.querySelector('.input_container.year')

        if (BX('299').closest('.radio_container').classList.contains('_error')) BX('299').closest('.radio_container').classList.remove('_error')

        selControlYearLocalStorage(this, checkSelectGroup)

        // Получаем объект с LC
        const dataLocalStorage = this.data.getStepLocalStorage(this.locStorStepId, this.data.step);
        let dataNew = {}

        if (monthContainer.classList.contains('_error')) {
            monthContainer.classList.remove('_error')
        }
        if (yearContainer.classList.contains('_error')) {
            yearContainer.classList.remove('_error')
        }

        if (e.target.checked && !checkSelectGroup.classList.contains('active')) {
            checkSelectGroup.classList.add('active')
        } else if (checkSelectGroup.classList.contains('active')) {
            checkSelectGroup.classList.remove('active')
        }

        // Если активный чекбокс
        if (target.checked) {
            if (disabledControl.classList.contains('disabled')) {
                disabledControl.classList.remove('disabled')
            }

            dataNew = {
                ...dataLocalStorage,
                [dataName]: true,
            }
        } else {
            if (!disabledControl.classList.contains('disabled')) {
                disabledControl.classList.add('disabled')
            }

            monthContainer.querySelector('span').innerText = 'Месяц'
            const inputs = monthContainer.querySelectorAll('.option_wrapper input')
            inputs.forEach(input => {
                input.checked = false
            })

            yearContainer.querySelector('input.input_control_js').value = ''

            dataNew = {
                ...dataLocalStorage,
                [dataName]: false,
                [dataName+'Month']: false,
                [dataName+'Year']: false,
            }
        }
        this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, dataNew, this.data.step);
    }
}

// Контролируем активность checkboxs по locStorage по загрузке (визуальное оформление)
function locStorageControlCheckbox (proxy, checkboxs, dataLS) {
    checkboxs.forEach(check => {
        const checkSelectGroup = check.closest('.check_select_group')
        const disabledControl = checkSelectGroup.querySelector('.disabled_control_js')

        if (dataLS[check.dataset.name]) {
            check.checked = dataLS[check.dataset.name]

            checkSelectGroup.classList.add('active')

            if (disabledControl.classList.contains('disabled')) {
                disabledControl.classList.remove('disabled')
            }
        } else {
            if (!disabledControl.classList.contains('disabled')) {
                disabledControl.classList.add('disabled')
            }
        }

        if (check.checked) {
            selControlYearLocalStorage(proxy, checkSelectGroup)
        }
    })
}

// Записываем в LocalStorage данные с текстовых инпутов
function setEventInputLocSt (e) {
    const data = this.data
    const step = 'step'+data.step;

    // Получаем объект с LC
    const dataLS = this.data.getStepLocalStorage(this.locStorStepId, this.data.step);

    dataLS[e.target.dataset.name] = e.target.value.trim()
    data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);
}

// Контролируем скрытое поле в блоке (Была ли у вас иранская виза ранее?)
function loadControlTypeFormerIranVisaRequired (proxy) {
    const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
    const typeFormerIranVisa = proxy.fvcContainerId.querySelector('input[data-name=typeFormerIranVisa]')
    if (dataLS.iranVisaBeforeId === '306') {
        typeFormerIranVisa.required = false
    }
    if (dataLS.iranVisaBeforeId === '307') {
        typeFormerIranVisa.required = true
    }

}

// Контролируем Border при переключении radio в календаре
function radioControlBorderCalendar (dataLS) {
    const dateRefused = document.querySelector('input[data-name=dateRefused]')
    if (dataLS.iranVisaDenialId === '304') {
        dateRefused.style.border = '1px solid #A4AAAF'
    }
    if (dataLS.iranVisaDenialId === '305') {
        dateRefused.style.border = '1px solid #017AC3'
    }
}
